import { Typography, TypographyProps } from '@mui/material';
import { styled } from '@mui/material/styles';
import { RookeryBoldFont, RookeryRegularFont } from 'v3/styles/common';

export const SubtitleMediumStyled = styled(Typography)<TypographyProps>(() => ({
  font: `400 1rem ${RookeryRegularFont}`,
}));

export const SubtitleMediumBoldStyled = styled(Typography)<TypographyProps>(() => ({
  font: `700 1rem ${RookeryBoldFont}`,
}));
